<div class="TotemWidget TotemWidgetCustomerCare card" role="button" tabindex="0" [attr.aria-label]="'totem-a11y.open-details' | locTranslate" (click)="requestFullScreen.emit()" (keydown)="onCardKeydown($event)">
    @if (isLoading) {
        <app-pg-loading></app-pg-loading>
    }
    @if (!isLoading) {
        <app-pg-availability-select availabilityType="user" [availabilityData]="filteredAvailabilityData"></app-pg-availability-select>
    }
</div>
